module.exports = __webpack_public_path__ + "be74450fb4c34fb88522e390161c0f48.png";